import $axios from '../config.js'
import { url } from '../api_urls/formulation.js'

export function getGoodsFormsListData (params) {
  return $axios.post(url.form, params)
}

export function getGoodsAspectsListData (params) {
  return $axios.post(url.aspects, params)
}

export function getGoodsSpaListData (params) {
  return $axios.post(url.SPF, params)
}

export function getGoodsPaListData (params) {
  return $axios.post(url.PA, params)
}

export function getBasfProductList (params) {
  return $axios.post(url.tradeNameList, params)
}

export function getTagList (params) {
  return $axios.post(url.tagList, params)
}

export function getFormulationList (params) {
  return $axios.post(url.formulationList, params)
}

// 获取页面顶部信息
export function getLastUpdateTime (params) {
  return $axios.post(url.getLastUpdateTime, params)
}

export function getRecommendProduct (params) {
  return $axios.post(url.recommendProductForList, params)
}

export function getTop10Product (params) {
  return $axios.post(url.recommendProduct, params)
}

export function getPhaseList (params) {
  return $axios.post(url.getPhaseList, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/formulationClient.js